export const permissionQueryKeys = {
  all: () => ['permissions'] as const,
};
